import { render } from "./Fade.vue?vue&type=template&id=185c1286&ts=true"
import script from "./Fade.vue?vue&type=script&lang=ts"
export * from "./Fade.vue?vue&type=script&lang=ts"

import "./Fade.vue?vue&type=style&index=0&id=185c1286&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__